import { useState } from "react"
import emailjs from "emailjs-com"
import {
  FormContainer,
  FormInput,
  FormWrapper,
  InputSection,
  SubmitButton,
  SuccessSubmit,
  TextArea,
} from "./form.styles"
import close from "../../assets/icons/close.svg"
import substract from "../../assets/icons/subtract.svg"
import Button from "../button/button.component"
import "./styles.scss"

const Form = ({ props }) => {
  const [isActive, setIsActive] = useState(false)
  const [phone, setPhone] = useState("")
  const [error, setError] = useState(false)

  const handleClick = () => {
    setIsActive(false)
  }

  function sendEmail(e) {
    e.preventDefault()
    if (!phone) {
      setError(true)
      return
    }
    emailjs
      .sendForm(
        "service_ua0wcso",
        "template_1gsnmax",
        e.target,
        "g3PKY7Wl6rUGSJAkz"
      )
      .then(
        (result) => {
          console.log(result.text)
        },
        (error) => {
          console.log(error.text)
        }
      )
    e.target.reset()
    setIsActive((current) => !current)
    setError(false)
    setPhone("")
  }

  return (
    <FormWrapper id="form">
      <FormContainer onSubmit={sendEmail}>
        <span className="form-info">{props.details}</span>
        <h2>{props[1]}</h2>

        <InputSection>
          <div className="phoneInput">
            <label htmlFor="phone">{props[2]}</label>
            <FormInput
              id="phone"
              name="user_phone"
              type="number"
              value={phone}
              style={{
                border: error ? "1px solid #D63535" : "",
              }}
              onChange={(e) => {
                setPhone(e.target.value)
                setError(false)
              }}
              placeholder="+39 389 518 1415"
              autoComplete="off"
            />
            {error ? <div className="error">{props[11]}</div> : ""}
          </div>
        </InputSection>

        <InputSection>
          <label htmlFor="car-model">{props[5]}</label>
          <FormInput
            id="car-model"
            name="car_model"
            type="text"
            autoComplete="off"
            placeholder={props[6]}
          />
        </InputSection>

        <InputSection>
          <label htmlFor="problem">{props[7]}</label>
          <TextArea
            id="problem"
            name="problem"
            type="textarea"
            autoComplete="off"
            placeholder={props[8]}
          ></TextArea>
          <SubmitButton>
            <Button children={props[10]} />
          </SubmitButton>
        </InputSection>

        <div
          style={{
            cursor: isActive ? "" : "default",
          }}
        >
          <SuccessSubmit
            style={{
              marginBottom: "4rem",
              opacity: isActive ? "1" : "0",
            }}
          >
            <div>
              <img src={substract} alt="" />
              <span>{props[9]}</span>
            </div>
            <img
              src={close}
              alt=""
              onClick={handleClick}
              style={{
                cursor: isActive ? "pointer" : "default",
              }}
            />
          </SuccessSubmit>
        </div>
      </FormContainer>
    </FormWrapper>
  )
}

export default Form